import React, { useEffect, useState } from "react";
import { api } from "../../lib/api";
import { toast } from "sonner";
import { Plus, Trash2, Star } from "lucide-react";

const cls = "w-full bg-[color:var(--ms-warm-white)] border border-[color:var(--ms-border)] focus:border-[color:var(--ms-charcoal)] px-3 py-2.5 text-sm outline-none text-[color:var(--ms-charcoal)]";

export default function AdminReviews() {
    const [items, setItems] = useState([]);
    const load = () => api.get("/admin/reviews").then(r => setItems(r.data));
    useEffect(() => { load(); }, []);

    const update = (i, key, val) => setItems(prev => prev.map((x, idx) => idx === i ? { ...x, [key]: val } : x));

    const save = async (item) => {
        try {
            if (item.id && !item.id.startsWith("new-")) {
                await api.put(`/admin/reviews/${item.id}`, item);
            } else {
                await api.post("/admin/reviews", item);
            }
            toast.success("Salvato");
            load();
        } catch (e) { toast.error("Salvataggio fallito"); }
    };

    const remove = async (id) => {
        if (!window.confirm("Eliminare recensione?")) return;
        if (id.startsWith("new-")) { setItems(prev => prev.filter(x => x.id !== id)); return; }
        await api.delete(`/admin/reviews/${id}`);
        toast.success("Eliminata");
        load();
    };

    const add = () => setItems(prev => [...prev, { id: `new-${Date.now()}`, name: "Nome Cliente", rating: 5, text: "Testo recensione…", is_published: true, sort_order: prev.length }]);

    return (
        <div data-testid="admin-reviews">
            <div className="flex justify-between items-center mb-10">
                <div>
                    <div className="overline mb-2">Recensioni Clienti</div>
                    <h1 className="font-display text-4xl text-[color:var(--ms-charcoal)]">Recensioni</h1>
                </div>
                <button onClick={add} className="bg-[color:var(--ms-charcoal)] text-[color:var(--ms-warm-white)] px-5 py-3 text-xs tracking-[0.2em] uppercase flex items-center gap-2 hover:bg-[color:var(--ms-sage-dark)]" data-testid="review-add"><Plus size={14} /> Nuova</button>
            </div>

            <div className="grid md:grid-cols-2 gap-4">
                {items.map((r, i) => (
                    <div key={r.id} className="panel p-5 space-y-3" data-testid={`review-card-${r.id}`}>
                        <div className="flex justify-between items-center">
                            <input value={r.name} onChange={e => update(i, "name", e.target.value)} className={cls} />
                            <button onClick={() => remove(r.id)} className="p-2 ml-2 hover:text-[color:var(--ms-terracotta)]"><Trash2 size={14} /></button>
                        </div>
                        <textarea rows={3} value={r.text} onChange={e => update(i, "text", e.target.value)} className={cls} />
                        <div className="flex justify-between items-center flex-wrap gap-2">
                            <div className="flex gap-1">
                                {[1, 2, 3, 4, 5].map(n => (
                                    <button key={n} onClick={() => update(i, "rating", n)} className={n <= r.rating ? "text-[color:var(--ms-ochre)]" : "text-[color:var(--ms-border)]"}><Star size={16} fill={n <= r.rating ? "currentColor" : "none"} /></button>
                                ))}
                            </div>
                            <label className="flex items-center gap-2 text-xs">
                                <input type="checkbox" checked={r.is_published} onChange={e => update(i, "is_published", e.target.checked)} className="accent-[color:var(--ms-sage-dark)]" /> Pubblicata
                            </label>
                            <button onClick={() => save(r)} className="border border-[color:var(--ms-charcoal)] px-3 py-1 text-xs tracking-[0.2em] uppercase hover:bg-[color:var(--ms-charcoal)] hover:text-[color:var(--ms-warm-white)]" data-testid={`review-save-${r.id}`}>Salva</button>
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
}
